import React, { useEffect, useState } from "react";
//import "./FilterTable.css";
//import { getGenreList } from "../../api/apiSetUp.js";
import { useDispatch } from "react-redux";
import { modifyFilterList } from "../../../page/FilterPage/FilterSlice.js";
import { modifyFilterStatementList } from "../../../page/FilterPage/FilterSlice.js";

import { SearchField } from "../../../components/ReactAria/SearchField.js";
import { MyCheckbox } from "../../../components/ReactAria/Checkbox.js";

export const GenreFilter = (props) => {
  const { genreList, className, focusSection } = props;
  let [currentSearchText, setCurrentSearchText] = useState("");
  let [checked, setChecked] = useState([]);
  let [checkedId, setCheckedId] = useState([]);
  let [filterStatement, setFilterStatement] = useState("");

  let current_genreList = genreList.filter((genre) =>
    genre.name.toLowerCase().includes(currentSearchText.toLowerCase())
  );

  const handleUnCheckAll = () => {
    setChecked([]);
    setCheckedId([]);
  };

  useEffect(() => {
    handleUnCheckAll();
    setCurrentSearchText("");
  }, [genreList]);

  //Update Filter List
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(modifyFilterList({
      field: "genre",
      payload: checkedId
    }))
    setFilterStatement(`(${checked.length}) ` + checked.join(", ") + " ");
  }, [checked]);
  //Update Statement List
  useEffect(() => {
    dispatch(modifyFilterStatementList({
      field: "genre",
      payload: filterStatement
    }))
  },[filterStatement])

  return (
    <div
      className={`${className} ${
        focusSection == className ? "filter_active" : ""
      }`}
    >
      <div className="genre_filter_content">
        <SearchField
          className={"genre_filter"}
          label={"Search for genres"}
          onChange={setCurrentSearchText}
          onClear={() => setCurrentSearchText("")}
          list={genreList}
        />
        <div className="genre_list_wrapper">
          {current_genreList.map((item) => (
            <MyCheckbox
              key={item.id}
              childrenId={item.id}
              children={item.name}
              setChecked={setChecked}
              checked={checked}
              checkedId={checkedId}
              setCheckedId={setCheckedId}
            >
              {item.name}
            </MyCheckbox>
          ))}
        </div>
      </div>
      <div
        className={`genre_filter_checked_display ${
          checked.length == 0 ? "hidden" : ""
        }`}
      >
        <p>You have selected:</p>
        <span>{filterStatement}</span>
        <div className="unchecked_all_btn" onClick={handleUnCheckAll}>
          <svg className="svg-icon" viewBox="0 0 20 20">
            <path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
          </svg>
          <div>Reset</div>
        </div>
      </div>
    </div>
  );
};
